import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import { faqs } from '@/mocks/events';

const values = [
  {
    icon: 'ri-scales-3-line',
    color: 'bg-primary-100 text-primary-600',
    title: '中立不站队',
    desc: '在吃瓜情绪最上头的时候，我们只做材料归拢。谁的证据更完整、更可核验，就如实陈列谁的材料。',
  },
  {
    icon: 'ri-file-user-line',
    color: 'bg-accent-100 text-accent-700',
    title: '逐条标来源',
    desc: '每一项素材都尽量写明类型、提供方与补档时间，帮助你把脱离上下文的单张截图放回完整语境里。',
  },
  {
    icon: 'ri-refresh-line',
    color: 'bg-secondary-100 text-secondary-900',
    title: '持续补档',
    desc: '事件会反转，材料会更新。我们如实标记持续更新、辟谣中、已辟谣等状态，而不是发完一次就定型。',
  },
];

const principles = [
  { icon: 'ri-archive-line', text: '只收录可公开来源与大致时间信息的素材，并对明显隐私内容做脱敏，不出售或诱导获取他人私密信息。' },
  { icon: 'ri-arrow-left-right-line', text: '收到反驳材料时不删原档，而是把正反证据并列放入同一条时间线，交由读者自行判断。' },
  { icon: 'ri-search-line', text: '优先鼓励读者回到官方原始发布与第三方机构凭证核验，任何脱离上下文的片段都应被审慎对待。' },
  { icon: 'ri-close-circle-line', text: '不煽动网暴、不诱导站队，涉及侵权与明显失实的指控，我们会下架相关条目。' },
];

const steps = [
  { n: '1', t: '线索初审', d: '你提交的线索先经初审，确认涉及可公开讨论的公共事件而非纯隐私纠纷。' },
  { n: '2', t: '素材整理', d: '按类型与时间归拢，标注来源，对敏感信息打码脱敏，保持时序完整。' },
  { n: '3', t: '归档发布', d: '生成事件档案，标注当前状态，并收录同主题的辟谣与反锤材料。' },
  { n: '4', t: '持续跟踪', d: '事件出现新进展或新素材时及时补档更新，保持档案的动态准确。' },
];

const quotes = [
  { q: '第一次见把吃瓜材料整理得这么规整的号，每张截图下面还标了来源，确实好比对。', tag: '站内读者留言 · 2026-08' },
  { q: '反锤材料不是删掉，而是并列贴出来让大家看，这个处理态度值得点赞。', tag: '网友反馈 · 2026-07' },
  { q: '遇到过类似退费纠纷，看完这份档案才知道要先比对合同和宣传话术，很受用。', tag: '读者来信 · 2026-09' },
];

const miscOnes = faqs.slice(1, 4);

export default function About() {
  return (
    <>
      <Seo
        title="关于我们 - 69爆料｜品牌介绍、内容原则与联系方式"
        description="了解69爆料的定位与发展理念：做最清晰的事件证据库。我们坚持中立不站队、逐条标来源、持续补档，并欢迎你通过页脚邮箱提交线索与建议。"
        keywords="69爆料关于我们,证据库定位,内容原则,联系投稿,69爆料联系方式"
        canonicalPath="/about"
      />

      {/* 品牌头 */}
      <section className="relative overflow-hidden bg-foreground-950 text-background-50">
        <div className="pointer-events-none absolute -right-20 -top-20 w-72 h-72 rounded-full bg-primary-500/20 blur-3xl"></div>
        <div className="pointer-events-none absolute -left-10 bottom-0 w-64 h-64 rounded-full bg-accent-500/15 blur-3xl"></div>
        <div className="relative max-w-[1200px] mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <nav className="flex items-center gap-1.5 text-xs text-background-300" aria-label="面包屑">
            <Link to="/" className="hover:text-secondary-300 transition-colors">档案首页</Link>
            <i className="ri-arrow-right-s-line"></i><span>关于我们</span>
          </nav>
          <div className="mt-6 max-w-3xl">
            <span className="stamp text-sm font-bold px-2.5 py-1">ABOUT 69</span>
            <h1 className="mt-5 font-display font-black text-3xl md:text-5xl leading-tight">
              关于 69爆料：我们想做的，
              <br className="hidden md:block" />是<span className="text-primary-400">最清晰的事件证据库</span>
            </h1>
            <p className="mt-4 text-background-200 text-sm md:text-lg leading-relaxed">
              我们是一群相信「吃瓜也要讲证据」的人。当一条爆料只剩情绪、没有上下文，真假就会越传越糊。
              所以 69爆料把散落在各平台的聊天截图、转账记录、录音影像整理成可核验的档案，帮每一个围观者把话说清、把料看全。
            </p>
          </div>
        </div>
      </section>

      {/* 定位理念 */}
      <section className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-display font-black text-foreground-950 text-2xl md:text-3xl">我们相信的三件事</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            信息越复杂，越需要一个干净的整理台。这三点是我们整理每份档案的底层逻辑。
          </p>
        </div>
        <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {values.map((v) => (
            <div key={v.title} className="bg-background-100/60 border border-background-200 rounded-lg p-6">
              <span className={`inline-flex items-center justify-center w-12 h-12 rounded-lg text-2xl ${v.color}`}>
                <i className={v.icon}></i>
              </span>
              <h3 className="mt-4 font-display font-bold text-foreground-950 text-lg">{v.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 内容原则 */}
      <section id="principles" className="bg-background-100/60 border-y border-background-200/70 scroll-mt-20">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <p className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
              <span className="inline-block w-8 border-t-2 border-primary-500"></span>内容原则
            </p>
            <h2 className="mt-3 font-display font-black text-foreground-950 text-2xl md:text-3xl">
              底线清晰，才有资格谈「真实」
            </h2>
            <p className="mt-4 text-foreground-600 leading-relaxed text-sm md:text-base max-w-xl">
              吃瓜与造谣往往只隔一线。我们用四条硬性原则约束自己，也欢迎你在发现违规内容时随时指出。
            </p>
            <div className="mt-6 space-y-3">
              {miscOnes.map((f) => (
                <div key={f.q} className="bg-background-50 border border-background-200 rounded-lg px-4 py-3">
                  <p className="font-medium text-foreground-950 text-sm flex items-center gap-2">
                    <i className="ri-question-line text-primary-500"></i>{f.q}
                  </p>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">{f.a}</p>
                </div>
              ))}
            </div>
            <Link to="/faq" className="mt-4 inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 text-sm font-medium">
              查看更多问答 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <ul className="space-y-3">
            {principles.map((p) => (
              <li key={p.text} className="flex gap-4 bg-background-50 border border-background-200 rounded-lg p-5">
                <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-accent-100 text-accent-700 text-lg shrink-0">
                  <i className={p.icon}></i>
                </span>
                <p className="text-sm text-foreground-700 leading-relaxed">{p.text}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* 工作流程 + 口碑 */}
      <section className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-background-100/60 border border-background-200 rounded-lg p-6 md:p-8">
            <h2 className="font-display font-bold text-foreground-950 text-xl md:text-2xl">一份档案如何诞生</h2>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {steps.map((s) => (
                <div key={s.n} className="relative bg-background-50 border border-background-200 rounded-lg p-4">
                  <span className="font-display font-black text-4xl text-primary-200">{s.n}</span>
                  <h3 className="mt-1 font-medium text-foreground-950">{s.t}</h3>
                  <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{s.d}</p>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h2 className="font-display font-bold text-foreground-950 text-xl md:text-2xl">围观者这样说</h2>
            <div className="mt-6 space-y-3">
              {quotes.map((q) => (
                <figure key={q.tag} className="bg-background-100/60 border border-background-200 rounded-lg p-5">
                  <i className="ri-double-quotes-l text-primary-300 text-2xl"></i>
                  <blockquote className="mt-2 text-foreground-700 leading-relaxed text-sm md:text-base">
                    {q.q}
                  </blockquote>
                  <figcaption className="mt-3 text-xs text-foreground-500">{q.tag}</figcaption>
                </figure>
              ))}
            </div>
            <p className="mt-4 flex items-start gap-2 text-xs text-foreground-500 leading-relaxed">
              <i className="ri-information-line text-primary-500 mt-0.5 shrink-0"></i>
              以上留言为站内读者反馈的归纳整理，不代表对任何具体事件的定性。
            </p>
          </div>
        </div>
      </section>

      {/* 联系投稿 */}
      <section id="contact" className="scroll-mt-20 bg-foreground-950 text-background-50">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <span className="stamp text-xs font-bold px-2 py-0.5">GET IN TOUCH</span>
            <h2 className="mt-4 font-display font-black text-2xl md:text-3xl">联系我们 &amp; 提交线索</h2>
            <p className="mt-3 text-background-200 text-sm md:text-base leading-relaxed max-w-xl">
              欢迎投稿可公开核验的线索，也欢迎指出站内可能存在的失实或侵权内容。
              为保证材料可信，投稿请尽量附上可公开的来源与大致时间；我们会先审核、脱敏，再决定是否补档。
            </p>
            <div className="mt-6 space-y-3">
              <a href="mailto:contact@69bao.cn" className="flex items-center gap-3 bg-background-50/10 hover:bg-background-50/20 rounded-lg px-4 py-3 transition-colors">
                <i className="ri-mail-line text-secondary-300 text-xl"></i>
                <div>
                  <p className="text-xs text-background-300">投稿 / 线索 / 申诉</p>
                  <p className="text-background-50 font-medium">contact@69bao.cn</p>
                </div>
              </a>
              <div className="flex items-center gap-3 bg-background-50/10 rounded-lg px-4 py-3">
                <i className="ri-time-line text-secondary-300 text-xl"></i>
                <div>
                  <p className="text-xs text-background-300">响应时间</p>
                  <p className="text-background-50 font-medium">工作日 48 小时内回复</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-background-100/60 rounded-lg p-6 md:p-8">
            <h3 className="font-display font-bold text-foreground-950 text-lg">投稿小贴士</h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700 leading-relaxed">
              <li className="flex gap-2.5"><i className="ri-checkbox-circle-line text-accent-600 shrink-0"></i>尽量提供可公开的来源链接，便于交叉核验。</li>
              <li className="flex gap-2.5"><i className="ri-checkbox-circle-line text-accent-600 shrink-0"></i>说明大致发生时间与所涉人物 / 事件背景。</li>
              <li className="flex gap-2.5"><i className="ri-checkbox-circle-line text-accent-600 shrink-0"></i>涉及隐私的信息请提前自行打码，我们也会二次脱敏。</li>
              <li className="flex gap-2.5"><i className="ri-checkbox-circle-line text-accent-600 shrink-0"></i>纯个人隐私纠纷或明显侵权内容，本站不予收录。</li>
            </ul>
            <Link
              to="/archive"
              className="mt-6 inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full px-6 py-2.5 text-sm transition-colors"
            >
              <i className="ri-arrow-left-line"></i>先去证据库看看
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}